angular
    .module('quattro.bmbo.search.box', [
        'quattro.bmbo.search.service',
    ])
    .directive('searchbox', function ($location, searchService) {
        return {
            restrict: 'E',
            templateUrl: 'bmbo/search/search-box.html',
            scope: {},
            controllerAs: 'vm',
            controller: function () {

                // $scope.searchService = searchService.scope;
                this.query = searchService.scope.query;

                this.submit = function () {

                    var url = [
                        'search',
                        this.query
                    ].join('/');
                    $location.path(url);
                };

                this.reset = function () {
                    this.query = '';
                };
            }
        };
    });
